import { useFormik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, Input, Button, Modal, ModalBody } from "reactstrap";
import { Chip } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { getClientUsersReq } from "../../service/usersService";
import AddUser from "../../components/CustomComponents/AddUser";
import { updateUserReq } from "../../service/usersService";
import { signinReq, forgotPasswordReq } from "../../service/authService"
import ActionComponent from "../../components/CustomComponents/ActionComponent";
import SendResetLinkConfirm from "../../components/CustomComponents/SendResetLinkConfirm";
import { toast } from "react-toastify";


const ClientUser = () => {
  const { clientId } = useParams();
  const gridRef = useRef();
  
  const [users, setUsers] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [openModal, setOpenModal] = useState({ user: false, branch: false });
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedUserEmail, setSelectedUserEmail] = useState('')
  const [showResetModal, setShowResetModal] = useState(false)
  const [edit, setEdit] = useState(null);
  const [userId, setUserId] = useState('second');
  const [paginationPageSize, setPaginationPageSize] = useState(25);
  const autoSizeStrategy = {
    type: "fitGridWidth",
  };
  const paginationPageSizeSelector = [25, 50, 100];

  const getUserData = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getClientUsersReq({
        clientId: clientId,
        

      });

      const list = response?.payload;

      const filteredUsers = Array.isArray(list)
        ? list.filter(
            (user) => user?.role?.title !== "Admin"
          )
        : [];

      setUsers(filteredUsers);

      const formattedData = filteredUsers.map((user) => ({
        _id: user._id,
        name: `${user.firstName || ""} ${user.lastName || ""
          }`,
        role: user?.role?.title || "-",
        email: user?.email || "-",
        contact: user?.contact || "-",
        status: user?.status || "-",
        associatedBranches:
          user?.associatedBranches || [],
      }));

      setRowData(formattedData);
    } catch (err) {
      console.error("API ERROR:", err?.response || err);
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientId) {
      getUserData();
    }
  }, [clientId]);
  const handleEdit = (data) => {
    setEdit(data);

    validation.setValues({
      primaryUser: {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        contact: data.contact,
        gender: data.gender,
        role: data.role,
        associatedBranches: data.associatedBranches,
      },
    });

    setSelectedItems(data.associatedBranches);

    setOpenModal({ ...openModal, user: true });
  };

  const handleSubmit = async (data, edit) => {
    try {
      if (edit) {
        const updatePayload = {
          id: edit,
          ...data,
        };
      await updateUserReq(updatePayload);
      } else {
        const createPayload = {
          ...data,
          clientId: clientId.toString(),
        };

        await signinReq(createPayload);
      }

      getUserData();
      setOpenModal({ ...openModal, user: false });
      validation.resetForm();
      setSelectedItems([]);
    } catch (err) {
      console.error(err);
    }
  };
  const validation = useFormik({
    initialValues: {
      primaryUser: {
        firstName: "",
        lastName: "",
        email: "",
        contact: "",
        gender: "",
        role: "",
        associatedBranches: [],
      },
    },

    onSubmit: (values) => {
      const payload = {
        ...values.primaryUser,
        associatedBranches: selectedItems.map((item) => item._id),
      };

      handleSubmit(payload, edit);

    },
  });

  const handleSendResetLink = async () => {
    try {
      const response = await forgotPasswordReq({
        email: selectedUserEmail,
      });
      if (response.success) {
        toast.success('Password reset link sent successfully!');
      } else {
        toast.error(response.message || 'Failed to send reset link');
      }
    } catch (error) {
      toast.error(error.message || 'Failed to send reset link');
    }
    setShowResetModal(false);
  };


  const columnDefs = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        sortable: true,
        minWidth: 220,
      },

      {
        headerName: "Role",
        field: "role",
        sortable: true,
        minWidth: 100,
      },

      {
        headerName: "Email",
        field: "email",
        sortable: true,
        minWidth: 280,
      },

      {
        headerName: "Contact",
        field: "contact",
        sortable: true,
        minWidth: 100,
      },

      {
        headerName: "Status",
        field: "status",
        sortable: true,
        minWidth: 100,

        cellRenderer: (params) => (
          <span
            style={{
              color:
                params.value === "active"
                  ? "green"
                  : "red",
              fontWeight: 500,
            }}
          >
            {params.value}
          </span>
        ),
      },

      {
        headerName: "Associated Branches",
        field: "associatedBranches",
        sortable: false,
        minWidth: 200,

        cellRenderer: (params) => {
          const branches = params.value || [];

          return (
            <div
              style={{
                display: "flex",
                gap: "4px",
                flexWrap: "wrap",
                paddingTop: "6px",
                paddingBottom: "6px",
              }}
            >
              {branches.length > 0 ? (
                branches.map((branch, index) => (
                  <Chip
                    key={index}
                    size="small"
                    label={
                      branch.code
                        ? branch.code
                        : branch.name
                    }
                  />
                ))
              ) : (
                <span>-</span>
              )}
            </div>
          );
        },
      },
      {
        headerName: "Action",
        field: "action",
        cellClass: "actions-button-cell",
        cellRenderer: ActionComponent,
        cellRendererParams: {
          setOpenModal: setOpenModal,
          type: "user",
          validation: validation,
          setUserId: setUserId,
          setEdit: setEdit,
          setShowResetModal: setShowResetModal,
          setSelectedUserEmail: setSelectedUserEmail,
        },
        sortable: false,
        suppressMenu: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
      },
    ],
    [validation]
  );
  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-4">
        <div
            className="search-box position-relative"
            style={{ width: "18rem" }}
          >
            <Input
              type="text"
              value={inputValue}
              onChange={(e) =>
                setInputValue(e.target.value)
              }
              className="form-control rounded border"
              placeholder="Search Users"
            />

            <i className="mdi mdi-magnify search-icon"></i>
          </div>
          <Button color="primary"
            onClick={() => {
              setEdit(null);
              validation.resetForm();
              setSelectedItems([]);
              setOpenModal({ ...openModal, user: true });
            }}>
            Add User
          </Button>
          <Modal
            isOpen={openModal.user}
            toggle={() =>
              setOpenModal({ ...openModal, user: true })
            }
            size="lg"
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <div className="modal-header">
                 <h5 className="modal-title">{edit ? 'Edit' : 'Add'} User</h5>

                <div>
                  <Button
                    type="button"
                    outline
                    color="danger"
                    className="waves-effect waves-light"
                    onClick={() => {
                      setEdit(null);
                      validation.resetForm();
                      setSelectedItems([]);
                      setOpenModal({ ...openModal, user: false });
                    }}
                  >
                    Close
                  </Button>

                  <Button
                    color="primary"
                    type="submit"
                    className="ms-2"
                  >
                    Save
                  </Button>
                </div>
              </div>

              <ModalBody>
                <AddUser
                  validation={validation}
                  clientId={clientId}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  modal={openModal}
                />
              </ModalBody>
            </form>
          </Modal>
        </div>

        {error && (
          <div className="text-danger mb-3">
            {error}
          </div>
        )}

        <div
          className="ag-theme-quartz"
          style={{
            height: "550px",
            width: "100%",
          }}
        >
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={
              paginationPageSizeSelector
            }
            autoSizeStrategy={autoSizeStrategy}
            suppressRowClickSelection={true}
            animateRows={true}
            loading={loading}
            reactiveCustomComponents
          />
        </div>

        {!loading && rowData.length === 0 && (
          <div className="text-center mt-3">
            No users found
          </div>
        )}

        {showResetModal && (
          <Modal
            isOpen={showResetModal}
            toggle={() => setShowResetModal(false)}
            centered
          >
            <SendResetLinkConfirm
              setConfirmModal={setShowResetModal}
              userEmail={selectedUserEmail}
              handleSendResetLink={handleSendResetLink}
            />
          </Modal>
        )}
      </CardBody>
    </Card>
  );
};

export default ClientUser;
